import {  QUERY_GET_CHECK_WORKER_SERVICE_STATUS } from '../../fetch/constantQueries'
import { baseThunk } from '../../fetch/basicThunk';

export const getWorkerServiceStatus = baseThunk("workerService/checkWorkerServiceStatus", QUERY_GET_CHECK_WORKER_SERVICE_STATUS, "GET")